<template>
  <a-modal
    class="dataset-dialog"
    :title="currentDataSet.chineseInstructions"
    width="1000px"
    v-model:visible="visible"
    :footer="false">
    <PicList ref="picList"
      :datasetId="currentDataSet.id"
      @settotal="setTotalCount"></PicList>
  </a-modal>
</template>
<script>
import PicList from './PicList'
export default {
  props: {
    currentDataSet: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    PicList
  },
  data () {
    return {
      visible: false,
      total: 0
    }
  },
  methods: {
    open () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.picList.reset()
      })
    },
    setTotalCount (e) {
      this.total = e
    }
  }
}
</script>
<style lang="less">
.dataset-dialog {
  .info-wrap {
    display: flex; flex-wrap: wrap;
    .info-item {
      width: 33%;
      padding: 20px; box-sizing: border-box;
      display: flex;
      .label {
        width: 70px; flex-shrink: 0;
      }
      .value {
        width: calc(100% - 70px);
      }
    }
  }
  .ctrl-wrap {
    text-align: right;
  }
  .pic-wrap {
    display: flex; flex-wrap: wrap;
    .pic-item {
      padding: 10px; box-sizing: border-box;
      width: 20%; text-align: center;
      img {
        width: 100%; height: 120px;
      }
    }
  }
}
</style>
